export const PATH_NAME = {
  DASHBOARD: "/",
  REPORT_DASHBOARD: "/report-dashboard",
  REPORT_CAMPAIGN_RESULT: "/report-campaign-result",
  USER_MANAGEMENT: "/user-management",
  ENTERPRISE_MANAGEMENT: "/enterprise-management",
  ENTERPRISE_MANAGEMENT_DETAILS: "/enterprise-management/:id",
  SUBSCRIPTION_MANAGEMENT: "/subscription-management",
  CREATE_SUBSCRIPTION_MANAGEMENT: "/subscription-management/create",
  EDIT_SUBSCRIPTION_MANAGEMENT: "/subscription-management/edit/:id",
  POS_MANAGEMENT: "/pos-management",
  REDEMPTION_MANAGEMENT: "/redemption-management",
  VIEW_REDEMPTION_MANAGEMENT: "/redemption-management/view/:id",
  PROFILE: "/profile",
  CHANGE_PASSWORD: "/change-password",
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  CAMPAIGN_MANAGEMENT: "/campaign-management",
};

export enum SCREEN_NAME {
  DASHBOARD = "Dashboard",
  USER_MANAGEMENT = "User Management",
  ENTERPRISE_MANAGEMENT = "Enterprise Management",
  SUBSCRIPTION_MANAGEMENT = "Subscription Management",
  POS_MANAGEMENT = "POS Management",
  REDEMPTION_MANAGEMENT = "Redemption Management",
  CAMPAIGN_MANAGEMENT = "Campaign Management",
}
